import { Component, Input } from '@angular/core';
import { Color, ScaleType } from '@swimlane/ngx-charts';

@Component({
    selector: 'app-conv-leaks-chart',
    templateUrl: './conv-leaks-chart.component.html',
    styleUrl: './conv-leaks-chart.component.scss',
    standalone: false
})
export class ConvLeaksChartComponent {
	// options
	legend = false;
	animations = false;
	xAxis = true;
	yAxis = false;
	showYAxisLabel = false;
	showXAxisLabel = true;
	min = 0;
	max = 100;
	colorScheme: string | Color = {
		name: 'myScheme',
		selectable: true,
		group: ScaleType.Ordinal,
		domain: ['transparent', '#15A607', '#F1D50A', '#F1960A', '#F11C0A'],
	};

	@Input() heatmap_leaks: any[] = [];
	@Input() heatmap_leaks_max_value = 0;
	chartData: any[] = [];

	ready = false;

	lastlbl = 0;
	lastrbl = 0;
	lastlbe = 0;
	lastrbe = 0;
	lastlel = 0;
	lastrel = 0;
	lastlee = 0;
	lastree = 0;

	series = [
		{ name: 'l_Brow lead', value: true },
		{ name: 'r_Brow lead', value: true },
		{ name: 'l_Brow exist', value: true },
		{ name: 'r_Brow exist', value: true },
		{ name: 'l_Eye lead', value: true },
		{ name: 'r_Eye lead', value: true },
		{ name: 'l_Eye exist', value: true },
		{ name: 'r_Eye exist', value: true }
	]

	// Heatmap rows (from top (index 7) to bottom (index 0)):
	// 7: right eye exist - ree
	// 6: left eye exist - lee
	// 5: right eye lead - rel
	// 4: left eye lead - lel
	// 3: right brow exist - rbe
	// 2: left brow exist - lbe
	// 1: right brow lead - rbl
	// 0: left brow lead - lbl

	showHeatmap() {
		this.max = this.heatmap_leaks_max_value;
		this.ready = true;
		this.calculateHeatMapData(20);
	}

	calculateHeatMapData(currentTime: number) {
		const start = currentTime - 20;
		const dataChart = [];

		for (let index = start; index <= currentTime; index++) {
			const time = this.convertToTimerFormat(index);

			let lbl;
			let rbl;
			let lbe;
			let rbe;
			let lel;
			let rel;
			let lee;
			let ree;

			if (index < this.heatmap_leaks[0].length) {
				lbl = this.heatmap_leaks[0][index];

				this.lastlbl = lbl;
			} else {
				lbl = this.lastlbl;
			}

			if (index < this.heatmap_leaks[1].length) {
				rbl = this.heatmap_leaks[1][index];

				this.lastrbl = rbl;
			} else {
				rbl = this.lastrbl;
			}

			if (index < this.heatmap_leaks[2].length) {
				lbe = this.heatmap_leaks[2][index];

				this.lastlbe = lbe;
			} else {
				lbe = this.lastlbe;
			}

			if (index < this.heatmap_leaks[3].length) {
				rbe = this.heatmap_leaks[3][index];

				this.lastrbe = rbe;
			} else {
				rbe = this.lastrbe;
			}

			if (index < this.heatmap_leaks[4].length) {
				lel = this.heatmap_leaks[4][index];

				this.lastlel = lel;
			} else {
				lel = this.lastlel;
			}

			if (index < this.heatmap_leaks[5].length) {
				rel = this.heatmap_leaks[5][index];

				this.lastrel = rel;
			} else {
				rel = this.lastrel;
			}

			if (index < this.heatmap_leaks[6].length) {
				lee = this.heatmap_leaks[6][index];

				this.lastlee = lee;
			} else {
				lee = this.lastlee;
			}

			if (index < this.heatmap_leaks[7].length) {
				ree = this.heatmap_leaks[7][index];

				this.lastree = ree;
			} else {
				ree = this.lastree;
			}

			let data = {};

			data = {
				name: time,
				series: [
					{ name: 'l_Brow lead', value: lbl, original: lbl },
					{ name: 'r_Brow lead', value: rbl, original: rbl },
					{ name: 'l_Brow exist', value: lbe, original: lbe },
					{ name: 'r_Brow exist', value: rbe, original: rbe },
					{ name: 'l_Eye lead', value: lel, original: lel },
					{ name: 'r_Eye lead', value: rel, original: rel },
					{ name: 'l_Eye exist', value: lee, original: lee },
					{ name: 'r_Eye exist', value: ree, original: ree }
				]
			};

			dataChart.push(data);
		}

		this.chartData = [...dataChart];

		if (!this.ready) {
			this.ready = true;
		}
	}

	tooltipText(data: any): string {
		const cell = JSON.parse(JSON.stringify(data)).cell;

		let spanContent;

		if (Array.isArray(cell.original)) {
			const listItems = cell.original.map((item: any) => `<li>${item}</li>`).join('');
			spanContent = `<ol>${listItems}</ol>`;
		} else {
			spanContent = cell.original;
		}

		const span = `<span>${spanContent}</span>`;

		const tool = `
			<div class="p-1 fs-16">
				${cell.series} - ${cell.name}
				<hr class="m-0">
				${span}
			</div>
		`;

		return tool;
	}

	updateHeatmap(currentTime: number) {
		this.max = this.heatmap_leaks_max_value;

		if (currentTime > 20) {
			this.calculateHeatMapData(currentTime);
		} else {
			this.calculateHeatMapData(20);
		}
	}

	convertToTimerFormat(seconds: number) {
		if (seconds < 3600) {
			// Display "mm:ss" format for the first 60 minutes
			const minutes = Math.floor(seconds / 60);
			const formattedSeconds = (seconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			return `${formattedMinutes}:${formattedSeconds}`;
		} else {
			// After 60 minutes, switch to "hh:mm:ss" format
			const hours = Math.floor(seconds / 3600);
			const remainingSeconds = seconds % 3600;
			const minutes = Math.floor(remainingSeconds / 60);
			const formattedSeconds = (remainingSeconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			const formattedHours = hours.toString().padStart(2, "0");
			return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
		}
	}
}
